import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const createVisit = async ({ trialId, visitName, visitSchedule, endVisitSchedule }) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${__API_URL__}/api/photos/create_visit/${trialId}/`,
    {
      visit_name: visitName,
      visit_schedule: visitSchedule,
      end_visit_schedule: endVisitSchedule,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useCreateVisitMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createVisit,
    // Returned so mutateAsync resolves only once the visits list has refetched
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["visits"] }),
  });
};

export default useCreateVisitMutation;
